var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnlineCourses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laptop-Man-Online_education-Learning-Communication",
    "data-name": "Laptop-Man-Online education-Learning-Communication"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45,12.28V8a.987.987,0,0,0-.62-.92l-12-5a.916.916,0,0,0-.76,0l-12,5a.993.993,0,0,0,0,1.84L25,11.17V21a7,7,0,0,0,14,0V11.17L43,9.5v2.78a2,2,0,1,0,2,0ZM37,21a5,5,0,0,1-10,0V17.28a17.721,17.721,0,0,0,10,0Zm0-5.84a15.978,15.978,0,0,1-10,0V12l4.62,1.92a.942.942,0,0,0,.76,0L37,12ZM32,9h7l-7,2.92L22.6,8,32,4.08,39,7H32a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.45,57.66l-6-12a3.093,3.093,0,0,0-.91-1.08A2.951,2.951,0,0,0,55,43V21a3.009,3.009,0,0,0-3-3H42a1,1,0,0,0,0,2H52a1,1,0,0,1,1,1V43a1,1,0,0,1-1,1H48V33.32a2.991,2.991,0,0,0-1.82-2.76l-5.79-2.48a.955.955,0,0,0-.84.03L32,31.88l-7.55-3.77a.989.989,0,0,0-.84-.03l-5.79,2.48A2.991,2.991,0,0,0,16,33.32V44H12a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1H22a1,1,0,0,0,0-2H12a3.009,3.009,0,0,0-3,3V43a2.951,2.951,0,0,0,.46,1.58,3.093,3.093,0,0,0-.91,1.08l-6,12A3,3,0,0,0,5.24,62H58.76a3,3,0,0,0,2.69-4.34ZM33,33.62l7.03-3.52,5.36,2.3a1,1,0,0,1,.61.92V44H33Zm-15-.3a1,1,0,0,1,.61-.92l5.36-2.3L31,33.62V44H18ZM59.61,59.53a.966.966,0,0,1-.85.47H5.24a.966.966,0,0,1-.85-.47,1.008,1.008,0,0,1-.05-.98l6-12a.992.992,0,0,1,.9-.55H52.76a.992.992,0,0,1,.9.55l6,12A1.008,1.008,0,0,1,59.61,59.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,56H25a1,1,0,0,0,0,2H39a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,4H5A1,1,0,0,0,5,2H3A1,1,0,0,0,3,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,4h6a1,1,0,0,0,0-2H9A1,1,0,0,0,9,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,8H5A1,1,0,0,0,5,6H3A1,1,0,0,0,3,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,8h6a1,1,0,0,0,0-2H9A1,1,0,0,0,9,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,12H5a1,1,0,0,0,0-2H3a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,12h6a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,16H5a1,1,0,0,0,0-2H3a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,16h6a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,4h2a1,1,0,0,0,0-2H49a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,4h6a1,1,0,0,0,0-2H55a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,8h2a1,1,0,0,0,0-2H49a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,6H55a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,12h2a1,1,0,0,0,0-2H49a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,10H55a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,16h2a1,1,0,0,0,0-2H49a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,14H55a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineCourses);
export default __webpack_public_path__ + "static/media/online-courses.bfc76e061115188d00be7a06480533c2.svg";
export { ForwardRef as ReactComponent };